module.exports = __webpack_public_path__ + "img/icon_tt.777c2c29.png";